// @copyright  2006-2023 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: '/:organisation/tax-compliance/tax-returns',
        component: () =>
            import('@/pages/[organisation]/tax-compliance/tax-returns.vue'),
        name: 'tax-compliance.tax-returns.search-tax-returns',
        meta: {
            loginRequired: true,
            permission: 'access.tax-compliance.view-tax-returns',
        },

        children: [
            {
                path: ':id/jm/gct',
                component: () =>
                    import('@/pages/[organisation]/tax-compliance/tax-returns/[id]/jm/gct/index.vue'),
                name: 'tax-compliance.tax-returns.jm-gct-form-4a',
                meta: {
                    loginRequired: true,
                    permission: 'access.tax-compliance.view-tax-returns',
                },
            },
            {
                path: ':taxReturnId/jm/gct/submissions/:submissionId/view',
                component: () =>
                    import('@/pages/[organisation]/tax-compliance/tax-returns/[taxReturnId]/jm/gct/submissions/[submissionId]/view.vue'),
                name: 'tax-compliance.tax-returns.view-gct-form',
                meta: {
                    loginRequired: true,
                    permission: 'access.tax-compliance.view-tax-submission',
                },
            },
            {
                path: ':id/jm/it02',
                component: () =>
                    import('@/pages/[organisation]/tax-compliance/tax-returns/[id]/jm/it02/index.vue'),
                name: 'tax-compliance.tax-returns.jm-it02-form',
                meta: {
                    loginRequired: true,
                    permission: 'access.tax-compliance.view-tax-returns',
                },
            },
            {
                path: ':taxReturnId/jm/it02/submissions/:submissionId/view',
                component: () =>
                    import('@/pages/[organisation]/tax-compliance/tax-returns/[taxReturnId]/jm/it02/submissions/[submissionId]/view.vue'),
                name: 'tax-compliance.tax-returns.view-it02-form',
                meta: {
                    loginRequired: true,
                    permission: 'access.tax-compliance.view-tax-submission',
                },
            },
            {
                path: ':taxReturnId/jm/it02/submissions/:submissionId/edit',
                component: () =>
                    import('@/pages/[organisation]/tax-compliance/tax-returns/[taxReturnId]/jm/it02/submissions/[submissionId]/edit.vue'),
                name: 'tax-compliance.tax-returns.edit-it02-form',
                meta: {
                    loginRequired: true,
                    permission: 'access.tax-compliance.generate-tax-submission',
                },
            },
            {
                path: ':id/jm/s04',
                component: () =>
                    import('@/pages/[organisation]/tax-compliance/tax-returns/[id]/jm/s04/index.vue'),
                name: 'tax-compliance.tax-returns.jm-s04-form',
                meta: {
                    loginRequired: true,
                    permission: 'access.tax-compliance.view-tax-returns',
                },
            },
            {
                path: ':taxReturnId/jm/s04/submissions/:submissionId/view',
                component: () =>
                    import('@/pages/[organisation]/tax-compliance/tax-returns/[taxReturnId]/jm/s04/submissions/[submissionId]/view.vue'),
                name: 'tax-compliance.tax-returns.view-s04-form',
                meta: {
                    loginRequired: true,
                    permission: 'access.tax-compliance.view-tax-submission',
                },
            },
            {
                path: ':taxReturnId/jm/s04/submissions/:submissionId/edit',
                component: () =>
                    import('@/pages/[organisation]/tax-compliance/tax-returns/[taxReturnId]/jm/s04/submissions/[submissionId]/edit.vue'),
                name: 'tax-compliance.tax-returns.edit-s04-form',
                meta: {
                    loginRequired: true,
                    permission: 'access.tax-compliance.generate-tax-submission',
                },
            },
            {
                path: ':id/jm/s01',
                component: () =>
                    import('@/pages/[organisation]/tax-compliance/tax-returns/[id]/jm/s01/index.vue'),
                name: 'tax-compliance.tax-returns.jm-s01-form',
                meta: {
                    loginRequired: true,
                    permission: 'access.tax-compliance.view-tax-returns',
                },
            },
            {
                path: ':id/jm/s02',
                component: () =>
                    import('@/pages/[organisation]/tax-compliance/tax-returns/[id]/jm/s02/index.vue'),
                name: 'tax-compliance.tax-returns.jm-s02-form',
                meta: {
                    loginRequired: true,
                    permission: 'access.tax-compliance.view-tax-returns',
                },
            },
            {
                path: ':id/jm/:code',
                component: () =>
                    import('@/pages/[organisation]/tax-compliance/tax-returns/[id]/jm/[code].vue'),
                name: 'tax-compliance.tax-returns.view-tax-return',
                meta: {
                    loginRequired: true,
                    permission: 'access.tax-compliance.view-tax-returns',
                },
            },
        ],
    },
];
